// !function(){"use strict";customElements.get("complementary-products")||customElements.define("complementary-products",class extends HTMLElement{constructor(){super()}connectedCallback(){new IntersectionObserver(((t,e)=>{t[0].isIntersecting&&(e.unobserve(this),this.hasAttribute("data-url")&&""!==this.getAttribute("data-url")&&fetch(this.getAttribute("data-url")).then((t=>t.text())).then((t=>{const e=document.createElement("div");e.innerHTML=t;const n=e.querySelector("complementary-products");n&&n.innerHTML.trim().length&&(this.innerHTML=n.innerHTML),this.initComplementarySlider()})).catch((t=>{console.error(t)})))}).bind(this),{rootMargin:"0px 0px 400px 0px"}).observe(this)}initComplementarySlider(){const t=this.querySelector("[data-complementary-slider]");if(!t)return;const e=this.querySelectorAll(".complementary-products__item");if(e.length>1){const n=new window.theme.Flickity(t,{wrapAround:!0,pageDots:!0,adaptiveHeight:!0,prevNextButtons:!1,on:{ready:()=>{e.forEach((t=>{if(!t.classList.contains("is-selected")){const e=t.querySelectorAll("a, button");e.length&&e.forEach((t=>{t.setAttribute("tabindex","-1")}))}}))}}});n.on("change",(t=>{n.cells.forEach(((e,n)=>{const r=e.element.querySelectorAll("a, button");r.length&&r.forEach((e=>{e.setAttribute("tabindex",n===t?"0":"-1")}))}))}))}}})}();

// !function() {
//   "use strict";
//   customElements.get("complementary-products") || customElements.define("complementary-products", class extends HTMLElement {
//     constructor() {
//       super();
//     }
//     connectedCallback() {
//       new IntersectionObserver(((entries, observer) => {
//         if (entries[0].isIntersecting) {
//           observer.unobserve(this);
//           if (this.hasAttribute("data-url") && "" !== this.getAttribute("data-url")) {
//             fetch(this.getAttribute("data-url"))
//               .then(r => r.text())
//               .then(html => {
//                 const div = document.createElement("div");
//                 div.innerHTML = html;
//                 const inner = div.querySelector("complementary-products");
//                 if (inner && inner.innerHTML.trim().length) {
//                   this.innerHTML = inner.innerHTML;
//                 }
//                 this.initComplementarySlider();
//               })
//               .catch(err => console.error(err));
//           }
//         }
//       }).bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
//     }
//     initComplementarySlider() {
//       const slider = this.querySelector("[data-complementary-slider]");
//       if (!slider) return;

//       const items = this.querySelectorAll(".complementary-products__item");
//       if (items.length <= 1) return;

//       const needsSlider = items.length > 2;

//       if (!needsSlider) {
//         // Static two-column layout, no Flickity
//         slider.style.cssText = "display:flex;";
//         items.forEach(el => el.style.width = "49%");
//         return;
//       }

//       // Force 50% width on all items before Flickity init
//       items.forEach(el => el.style.width = "49%");

//       const flkty = new window.theme.Flickity(slider, {
//         wrapAround: true,
//         pageDots: true,
//         adaptiveHeight: true,
//         prevNextButtons: false,
//         cellAlign: 'left',      
//         groupCells: false,     
//         contain: false,       
//         on: {
//           ready: () => {
//             items.forEach(item => {
//               if (!item.classList.contains("is-selected")) {
//                 item.querySelectorAll("a, button")
//                   .forEach(el => el.setAttribute("tabindex", "-1"));
//               }
//             });
//           }
//         }
//       });

//       flkty.on("change", index => {
//         flkty.cells.forEach((cell, i) => {
//           cell.element.querySelectorAll("a, button")
//             .forEach(el => el.setAttribute("tabindex", i === index ? "0" : "-1"));
//         });
//       });
//     }
//   });
// }();

// !function() {
//   "use strict";
//   customElements.get("complementary-products") || customElements.define("complementary-products", class extends HTMLElement {
//     constructor() {
//       super();
//     }
//     connectedCallback() {
//       new IntersectionObserver(((entries, observer) => {
//         if (entries[0].isIntersecting) {
//           observer.unobserve(this);
//           if (this.hasAttribute("data-url") && "" !== this.getAttribute("data-url")) {
//             fetch(this.getAttribute("data-url"))
//               .then(r => r.text())
//               .then(html => {
//                 const div = document.createElement("div");
//                 div.innerHTML = html;
//                 const inner = div.querySelector("complementary-products");
//                 if (inner && inner.innerHTML.trim().length) {
//                   this.innerHTML = inner.innerHTML;
//                 }
//                 // this.initComplementarySlider();
//               })
//               .catch(err => console.error(err));
//           }
//         }
//       }).bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
//     }
//     initComplementarySlider() {
//       const slider = this.querySelector("[data-complementary-slider]");
//       if (!slider) return;

//       const items = this.querySelectorAll(".complementary-products__item");
//       if (items.length <= 1) return;

//       const isMobile = window.innerWidth < 768;
//       const needsSlider = items.length > 1;

//       // Static two-column layout for exactly 2 items on desktop
//       if (!needsSlider && !isMobile) {
//         slider.style.cssText = "display:flex;";
//         items.forEach(el => el.style.width = "49%");
//         return;
//       }

//       // Set cell width before Flickity init
//       items.forEach(el => el.style.width = isMobile ? "100%" : "49%");

//       const flkty = new window.theme.Flickity(slider, {
//         wrapAround: true,
//         pageDots: true,
//         adaptiveHeight: true,
//         prevNextButtons: false,
//         cellAlign: 'left',
//         groupCells: false,
//         contain: false,
//         on: {
//           ready: () => {
//             items.forEach(item => {
//               if (!item.classList.contains("is-selected")) {
//                 item.querySelectorAll("a, button")
//                   .forEach(el => el.setAttribute("tabindex", "-1"));
//               }
//             });
//           }
//         }
//       });

//       flkty.on("change", index => {
//         flkty.cells.forEach((cell, i) => {
//           cell.element.querySelectorAll("a, button")
//             .forEach(el => el.setAttribute("tabindex", i === index ? "0" : "-1"));
//         });
//       });
//     }
//   });
// }();


!function() {
  "use strict";
  customElements.get("complementary-products") || customElements.define("complementary-products", class extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      new IntersectionObserver(((entries, observer) => {
        if (entries[0].isIntersecting) {
          observer.unobserve(this);
          const url = this.getAttribute("data-url");
          if (url && url !== "") {
            this.loadProducts(url);
          }
        }
      }).bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);

      document.addEventListener("cart:updated", () => this.refreshVisible());
      document.addEventListener("cart:add", () => this.refreshVisible());
    }

    async loadProducts(url) {
      try {
        const [html, cart] = await Promise.all([
          fetch(url).then(r => r.text()),
          fetch("/cart.js").then(r => r.json())
        ]);

        const div = document.createElement("div");
        div.innerHTML = html;
        const inner = div.querySelector("complementary-products");
        if (!inner || !inner.innerHTML.trim().length) return;

        this._allItems = [...inner.querySelectorAll(".complementary-products__item")];
        this._cartProductIds = cart.items.map(item => String(item.product_id));

        this.innerHTML = "";

        // Copy header if exists
        const header = inner.querySelector(".section__header");
        if (header) this.appendChild(header.cloneNode(true));

        // ✅ Store and append the title separately so we can show/hide it independently
        const title = inner.querySelector(".complementary-products__title");
        if (title) {
          this._title = title.cloneNode(true);
          this.appendChild(this._title);
        }

        // Build slider container
        const sliderSource = inner.querySelector("[data-complementary-slider]");
        if (sliderSource) {
          this._slider = document.createElement("div");
          this._slider.className = sliderSource.className;
          this._slider.setAttribute("data-complementary-slider", "");
          this.appendChild(this._slider);
        }

        this.renderVisible();

      } catch (err) {
        console.error("Complementary products error:", err);
      }
    }

    async refreshVisible() {
      if (!this._allItems) return;
      try {
        const cart = await fetch("/cart.js").then(r => r.json());
        this._cartProductIds = cart.items.map(item => String(item.product_id));
        this.renderVisible();
      } catch (err) {
        console.error(err);
      }
    }

    renderVisible() {
      if (!this._allItems || !this._slider) return;

      const isExtendedPage = document.body.matches("#the-am-kit, #the-pm-kit");
      const sliceLimit = isExtendedPage ? 3 : 2;

      const visible = this._allItems
        .filter(item => {
          const productId = item.querySelector("[data-product-id]")?.getAttribute("data-product-id");
          return productId ? !this._cartProductIds.includes(productId) : true;
        })
        .slice(0, sliceLimit);

      this._slider.innerHTML = "";

      if (visible.length === 0) {
        // ✅ Hide only the slider and title, not the whole component
        this._slider.style.display = "none";
        if (this._title) this._title.style.display = "none";
        return;
      }

      // ✅ Restore visibility
      this._slider.style.display = "";
      if (this._title) this._title.style.display = "";

      visible.forEach(item => {
        this._slider.appendChild(item.cloneNode(true));
      });
    }

    initComplementarySlider() {
      const slider = this.querySelector("[data-complementary-slider]");
      if (!slider) return;

      const items = this.querySelectorAll(".complementary-products__item");
      if (items.length <= 1) return;

      const isMobile = window.innerWidth < 768;
      const needsSlider = items.length > 2;

      // Static two-column layout for exactly 2 items on desktop
      if (!needsSlider && !isMobile) {
        slider.style.cssText = "display:flex;";
        items.forEach(el => el.style.width = "49%");
        return;
      }

      // Set cell width before Flickity init
      items.forEach(el => el.style.width = isMobile ? "100%" : "49%");

      const flkty = new window.theme.Flickity(slider, {
        wrapAround: true,
        pageDots: true,
        adaptiveHeight: true,
        prevNextButtons: false,
        cellAlign: 'left',
        groupCells: false,
        contain: false,
        on: {
          ready: () => {
            items.forEach(item => {
              if (!item.classList.contains("is-selected")) {
                item.querySelectorAll("a, button")
                  .forEach(el => el.setAttribute("tabindex", "-1"));
              }
            });
          }
        }
      });

      flkty.on("change", index => {
        flkty.cells.forEach((cell, i) => {
          cell.element.querySelectorAll("a, button")
            .forEach(el => el.setAttribute("tabindex", i === index ? "0" : "-1"));
        });
      });
    }
  });
}();